/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AiOfferBatch from './AiOfferBatch';
import AiOfferDraftItem from './AiOfferDraftItem';

/**
 * The AiOfferBatchDetailResponse model module.
 * @module model/AiOfferBatchDetailResponse
 * @version 1.0.0
 */
class AiOfferBatchDetailResponse {
    /**
     * Constructs a new <code>AiOfferBatchDetailResponse</code>.
     * @alias module:model/AiOfferBatchDetailResponse
     */
    constructor() { 
        
        AiOfferBatchDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AiOfferBatchDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferBatchDetailResponse} obj Optional instance to populate.
     * @return {module:model/AiOfferBatchDetailResponse} The populated <code>AiOfferBatchDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferBatchDetailResponse();

            if (data.hasOwnProperty('batch')) {
                obj['batch'] = AiOfferBatch.constructFromObject(data['batch']);
            }
            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [AiOfferDraftItem]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferBatchDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferBatchDetailResponse</code>.
     */
    static validateJSON(data) {
        // validate the optional field `batch`
        if (data['batch']) { // data not null
          AiOfferBatch.validateJSON(data['batch']);
        }
        if (data['items']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['items'])) {
                throw new Error("Expected the field `items` to be an array in the JSON data but got " + data['items']);
            }
            // validate the optional field `items` (array)
            for (const item of data['items']) {
                AiOfferDraftItem.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {module:model/AiOfferBatch} batch
 */
AiOfferBatchDetailResponse.prototype['batch'] = undefined;

/**
 * user_id の昇順ではなく item の作成順（＝依頼時の並び）で返る
 * @member {Array.<module:model/AiOfferDraftItem>} items
 */
AiOfferBatchDetailResponse.prototype['items'] = undefined;






export default AiOfferBatchDetailResponse;

